<template>
  <section class="home-block">
    <div class="background">
      <div ref="background" class="video-background">
        <picture>
          <source
            :srcset="require('@i/video/home-lifestyle-s.jpg')"
            media="(max-width: 767px)"
          />
          <img
            :src="require('@i/video/home-lifestyle.jpg')"
            loading="lazy"
            width="1920"
            height="1080"
            alt=""
          />
        </picture>
      </div>
    </div>
    <div class="content">
      <div class="container">
        <div ref="title" class="title h1">
          Основа <br />
          Новой Формы
        </div>
        <div class="row">
          <div class="col-lg-7 col-md-9 offset-lg-4 offset-md-3">
            <div ref="text" class="text">
              <p>
                Сенсация – это современный жилой комплекс, расположенный в
                живописном уголке Читы, где гармонично сочетаются городская
                динамика и природное спокойствие. Район предлагает уникальную
                возможность наслаждаться прекрасными видами на реку, не
                отказываясь от преимуществ близости к центру города. До одной из
                главных транспортных артерий – ул. Красной Звезды, всего 5
                минут, а до сердца Читы – 15.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { lazyVideo, is_touch } from "@/helpers.js";
import { gsap } from "gsap";
export default {
  mounted() {
    lazyVideo(this.$el);

    if (!is_touch()) {
      gsap.fromTo(
        this.$refs.background,
        { y: "-25%" },
        {
          y: "25%",
          scrollTrigger: {
            trigger: this.$el,
            scrub: true,
          },
          ease: "none",
        }
      );

      gsap
        .timeline({
          scrollTrigger: {
            trigger: this.$el,
            start: "top 60%",
            end: "center center",
            scrub: 1.5,
          },
        })
        .from(
          gsap.utils.toArray([
            // this.$refs.h1,
            this.$refs.title,
            this.$refs.text,
          ]),
          {
            y: 50,
            stagger: { each: 0.1 },
          }
        );
    }
  },
};
</script>

<style scoped>
.home-block {
  padding-top: 0;
}

body.-notouch .video-background {
  top: -25%;
  bottom: -25%;
  height: auto;
}

.background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.background::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(255 255 255 / 0.5);
}

.content {
  position: relative;
}

h1 {
  text-align: center;
}

.title {
  margin: 96px 0 72px;
  color: #545863;
  font-weight: 700;
  font-size: 120px;
  line-height: 110%;
}

.row {
  justify-content: center;
}

.text {
  color: #291f1f99;
  font-weight: 500;
  font-size: 18px;
}

@media (max-width: 1279px) {
  .title {
    font-size: 136px;
  }
}
@media (max-width: 991px) {
  .title {
    font-size: 112px;
  }
}
@media (max-width: 767px) {
  .content {
    text-align: center;
  }

  .title {
    margin-bottom: 30px;
    font-size: 88px;
  }

  .text {
    font-size: 16px;
  }
}
@media (max-width: 575px) {
  .title {
    margin: 48px 0 24px;
    font-size: 48px;
    text-align: left;
  }

  .text {
    text-align: left;
  }

  .col-lg-7,
  .col-md-9 {
    padding-right: 24px;
    padding-left: 48px;
  }
}
</style>
